import {  configureStore } from "@reduxjs/toolkit"
import { combineReducers, compose, Middleware} from "redux"
import appReducer from '../reducer/index';
import { routerMiddleware } from 'react-router-redux';
import  {createBrowserHistory} from 'history';
declare global {
    interface Window {
        __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
    }
}
const reducers = combineReducers({
    appReducer,
})
const history = createBrowserHistory();
const composeEnhancer =  window['__REDUX_DEVTOOLS_EXTENSION_COMPOSE__']  || compose;
const enhancer = composeEnhancer(routerMiddleware(history));
// const store = createStore(reducers,enhancer)
const store = configureStore({
    reducer: reducers,
    middleware: (getDefaultMiddleware)=> getDefaultMiddleware({
          immutableCheck: false,
        serializableCheck: false,
    }).concat(routerMiddleware(history) as Middleware)
 //   enhancers: [enhancer] 
})
export default store;